var _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNearby = function SvgNearby(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73882 13.0732C9.49245 11.3238 9.4333 9.21431 8.38744 7.40282C7.34157 5.59132 5.54426 4.48535 3.65246 4.26334C3.10394 4.19896 2.71146 3.70212 2.77583 3.15359C2.84021 2.60507 3.33706 2.2126 3.88558 2.27697C6.38755 2.57059 8.74922 4.02944 10.1195 6.40282C11.4898 8.77619 11.5723 11.5509 10.5756 13.8645C10.3571 14.3717 9.76879 14.6057 9.26157 14.3872C8.75435 14.1687 8.52031 13.5804 8.73882 13.0732ZM5.04408 11.8071C5.36013 11.0735 5.33641 10.185 4.89458 9.41977C4.45275 8.65449 3.69518 8.18973 2.90183 8.09662C2.35331 8.03225 1.96083 7.5354 2.0252 6.98688C2.08957 6.43836 2.58642 6.04588 3.13494 6.11025C4.53847 6.27497 5.8604 7.09261 6.62663 8.41977C7.39287 9.74693 7.44 11.3006 6.88089 12.5984C6.66237 13.1056 6.07405 13.3397 5.56683 13.1212C5.05962 12.9027 4.82557 12.3143 5.04408 11.8071Z",
    fill: "#3B424A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0864258,
    y: 4.02216,
    width: 7.495,
    height: 14.14,
    transform: "rotate(-30 0.0864258 4.02216)",
    fill: "#2CD574"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNearby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nearby.b9101b75.svg";
export { ForwardRef as ReactComponent };